/*
| Shared circular initials avatar for JS-rendered spots — the TS twin of the
| Blade <x-planning::avatar>. Single .pl-av look everywhere (filters, combobox,
| claims, calendar, coverage, …).
*/
const esc = (v: unknown): string => String(v ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string
));

export function avatarEl(initials: string, color: string, size: 'sm' | 'md' | 'lg' = 'md'): string {
    return `<span class="pl-av pl-av--${size} bg-${esc(color)}-300">${esc(initials)}</span>`;
}
